<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div className="animated">
            <b-card header-tag="header" footer-tag="footer">
              <div slot="header">
                <i class="fa fa-truck"></i
                ><strong>
                  Formulario de <big class="text-uppercase text-primary">{{ waybillType }}</big> de guía de
                  despacho</strong
                >
                <div class="card-header-actions">
                  <small class="text-muted">-</small>
                </div>
              </div>
              <form-wizard
                color="#20a8d8"
                errorColor="#f86c6b"
                ref="wizard"
                nextButtonText="Siguiente"
                backButtonText="Atrás"
                finishButtonText="Finalizar"
                @on-complete="onComplete"
                title=""
                subtitle=""
              >
                <tab-content title="Información del documento" :before-change="submitWaybill">
                  <waybill-form ref="waybillForm" @validate="formStepVal1 = $event" :waybillData="waybillData">
                  </waybill-form>
                </tab-content>

                <tab-content title="Detalle de la guía (Materiales)" :before-change="getCompleteWaybill">
                  <b-row class="mb-2">
                    <b-col>
                      <supply-detail-form
                        ref="supplyForm"
                        :waybillID="waybillData.id"
                        :waybillType="waybill_type"
                        :supplyDetailData="supplyDetailData"
                        :items="items"
                      >
                      </supply-detail-form>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-table hover small fixed :fields="fields" :items="items">
                        <template v-slot:cell(quantity)="data">
                          {{ data.item.quantity }}
                        </template>

                        <template v-slot:cell(actions)="data">
                          <a
                            target="_blank"
                            @click.prevent="deleteSupplyDetail(data.item)"
                            href="#"
                            class="fa fa-lg fa-trash text-danger pull-right"
                          ></a>
                          <a
                            target="_blank"
                            @click.prevent="editSupplyDetail(data.item)"
                            href="#"
                            class="fa fa-lg fa-pencil text-primary pull-right"
                          >
                          </a
                          >&nbsp;
                          <a
                            target="_blank"
                            href="#"
                            @click.prevent="printContent(data.item)"
                            class="fa fa-lg fa-print text-primary pull-right"
                          >
                          </a
                          >&nbsp;
                        </template>
                      </b-table>
                      <printContent ref="printContent"></printContent>
                    </b-col>
                  </b-row>
                </tab-content>
                <tab-content title="Reporte">
                  <report v-if="waybill" ref="report" :waybill="waybill"></report>
                </tab-content>
              </form-wizard>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import printContent from "../printComponent/printContent.vue";
import { bus } from "../../main";
import WaybillForm from "./WaybillForm.vue";
import SupplyDetailForm from "./SupplyDetailForm.vue";
import numeral from "numeral";
import locale from "numeral/locales";
import Report from "./Report";

numeral.locale("es");

import miniToastr from "mini-toastr";
const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

export default {
  name: "CreateSupplyWaybill",
  props: ["waybill_type", "edit_waybill", "waybillID"],
  data() {
    return {
      waybill: null,
      formStepVal1: false,
      validated: false,
      waybillData: {
        id: null,
        client_customer: "",
        company: "",
        number: null,
        waybill_date: null,
        note: null,
        internal_note: null,
        truck_driver: null,
        license_plate: null,
        recipient: null
      },
      supplyDetailData: {
        supply: null,
        quantity: null,
        supply_lot: ""
      },
      items: [],
      fields: [
        { key: "supply_code", label: "Código" },
        { key: "supply_name", label: "Material" },
        { key: "supply_lot", label: "Lote material" },
        { key: "quantity", label: "Cantidad" },
        { key: "actions", label: " " }
      ]
    };
  },
  beforeMount() {
    this.$store.dispatch("getCustomers");
  },
  mounted() {
    this.edit_waybill = false;
    if (this.waybillID != null) {
      this.loadWaybill(this.waybillID);
      this.edit_waybill = true;
    }

    this.$barcodeScanner.destroy();
  },
  filter: {
    decimal(value) {
      return numeral(value).format("0.0,00");
    }
  },
  components: {
    FormWizard,
    TabContent,
    WaybillForm,
    printContent,
    Report,
    SupplyDetailForm
  },
  created() {},
  computed: {
    waybillType() {
      return this.waybill_type == 3 ? "Entrada" : "Salida";
    }
  },
  methods: {
    onComplete() {
      this.$router.push("/materiales/lista");
    },
    loadWaybill(a) {
      this.$axios
        .get("/api/supplies/waybill/" + a + "/")
        .then((res) => {
          this.waybillData.id = res.data.id;
          this.waybillData.number = res.data.number;
          this.waybillData.waybill_date = res.data.waybill_date;
          this.waybillData.internal_note = res.data.internal_note;
          this.waybillData.note = res.data.note;
          this.waybillData.license_plate = res.data.license_plate;
          this.waybillData.truck_driver = res.data.truck_driver;
          this.waybillData.client_customer = res.data.client_customer;
          this.$refs.waybillForm.getCompanies(res.data.client_customer);
          this.waybillData.company = res.data.company;
          this.waybillData.recipient = res.data.recipient_company;
          this.waybillData.client = res.data.client;
          this.loadDetails(res.data.id);
          this.$refs.waybillForm.$v.$touch();
        })
        .catch((error) => console.log(error));
    },
    loadDetails(a) {
      this.$axios
        .get("api/supplies/waybill/" + a + "/waybill_detail/")
        .then((res) => {
          this.items = res.data;
        })
        .catch((error) => console.log(error));
    },
    getCompleteWaybill() {
      this.$axios
        .get("/api/supplies/waybill/" + this.waybillData.id + "/waybill_report/")
        .then((res) => {
          this.waybill = res.data;
        })
        .catch((error) => console.log(error));
      return true;
    },
    deleteSupplyDetail(a) {
      this.$axios({
        method: "delete",
        url: "/api/supplies/waybill-supply/" + a.id + "/"
      })
        .then((res) => {
          miniToastr.success("Detalle de guía eliminado con éxito", "");
          this.items.splice(this.items.indexOf(a), 1);
        })
        .catch((error) => {
          miniToastr.error(error.response.data, "");
          console.log(error);
        });
    },
    editSupplyDetail(data) {
      bus.$emit("editSupplyDetail", data);
    },
    printContent(data) {
      data["waybill_data"] = this.waybillData;
      this.$refs.printContent.modalShown = true;
      this.$refs.printContent.contentPrint = data;
    },
    submitWaybill() {
      this.$refs.waybillForm.submit();
      if (this.formStepVal1 === true) {
        parent = this;
        return this.saveWaybill();
      } else {
        return false;
      }
    },
    saveWaybill: async () => {
      const formData = {
        number: parent.waybillData.number,
        waybill_date: parent.waybillData.waybill_date,
        waybill_type: parent.waybill_type,
        // arrival_datetime: parent.waybillData.arrival_datetime,
        internal_note: parent.waybillData.internal_note,
        note: parent.waybillData.note,
        license_plate: parent.waybillData.license_plate,
        truck_driver: parent.waybillData.truck_driver,
        company: parent.waybillData.company,
        client_customer: parent.waybillData.client_customer,
        recipient_company: parent.waybillData.recipient
      };
      if (parent.edit_waybill === false) {
        try {
          const res = await parent.$axios
            .post("/api/v1/waybill/", formData)
            .then((res) => {
              miniToastr.success("Guía creada con éxito", "");
              parent.waybillData.id = res.data.id;
              parent.edit_waybill = true;
              parent.validated = true;
              // parent.getContents(res.data.id);
            })
            .catch(function (error) {
              parent.$swal.fire(error.response.data.non_field_errors[0], "", "warning");
              parent.validated = false;
            });
        } catch (err) {
          console.log("erroor" + err);
        }
      } else {
        try {
          const res = await parent.$axios
            .put("/api/v1/waybill/" + parent.waybillData.id + "/", formData)
            .then((res) => {
              miniToastr.info("Guía actualizada con éxito", "");
              parent.waybillData.id = res.data.id;
              parent.validated = true;
              // parent.getContents(res.data.id)
            })
            .catch(function (error) {
              parent.$swal.fire(error.response.data.non_field_errors[0], "", "warning");
              parent.validated = false;
            });
        } catch (err) {
          console.error("erroor" + err);
        }
      }

      return parent.validated;
    }
  }
};
</script>

<style scoped></style>
